import Icon from '../components/Icon.vue'

Icon.register({
  'undo-alt': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M255.5 8c136.8-0.2 248.5 111.2 248.5 248 0 137-111 248-248 248-63.9 0-122.2-24.2-166.2-63.9-5.1-4.6-5.4-12.6-0.5-17.4l39.7-39.7c4.5-4.5 11.6-4.7 16.4-0.6 30.6 26.9 69.5 41.6 110.6 41.6 93.8 0 167.2-76 168-166.6 0.8-95.5-77.1-170.2-169.5-169.4-42.4 0.4-82.4 16.4-113.2 45.3l41.8 41.8c15.1 15.1 4.4 41-17 41h-134.1c-13.3 0-24-10.7-24-24v-134.1c0-21.4 25.9-32.1 41-17l35.7 35.7c44.4-42.5 104.6-68.6 170.9-68.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/undo-alt.js
// module id = 2048
// module chunks = 0